import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DrugPlan } from '../../models/drug-plan'
import { Notes } from '../../models/notes'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { Router } from '@angular/router'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { PaymentOption, PaymentOptions } from '../../models/payment-options'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { SubmitEnrollmentDataResponse } from '../../models/submit-enrollment-data-response'
import { PortalGlobals } from '../../../portalglobals'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../models/EnrollmentCacheData'
import { UtilsService } from '../common/utils-service'
import { IndvRepComponent } from '../common/indvrep.component'

@Component({
    selector: 'DataEntryStep3',
    templateUrl: 'data-entry-step3.html'
})
export class DataEntryStep3Component implements OnInit {
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    drugPlanModel = {} as DrugPlan
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    notesModel = {} as Notes
    isValidAgent: boolean
    isAuthRep: boolean
    selAuthorizedRep: string
    selrblMailCopy: string
    selectPlan: string
    selectedPlan: string
    paymentMethod: typeof PaymentOptions
    public rblAuthorizedRep: ValidatedRadioButtonModel[] = []
    public rblMailCopy: ValidatedRadioButtonModel[] = []
    rblRelation: ValidatedSelectOptionModel[] = []

    @Input() states: State[]
    numericTextFieldValidator = new NumericTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)
    showTermsButton: boolean
    hasError: boolean
    ErrorMessages: any[]
    public loading: boolean = false
    orgName: string
    hasIncompleteError: boolean
    disableEffectiveDate: boolean
    planYear2018: boolean
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    insuranceCompany: string
    insuranceCompanyShortName: string
    insComAetnaPdp: string
    insuranceCompanyFullShort: string
    public rblReltoEnroll: ValidatedSelectOptionModel[] = []
    visibleAfter2025: boolean

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    // constructor(private route: ActivatedRoute) {
    constructor(
        private router: Router,
        private utils: UtilsService,
        private _indvRepComponent: IndvRepComponent,
        private _stateGateway: StateGateway,
        private _enrollementGateway: EnrollmentGateway,
        public _global: PortalGlobals
    ) {
        this.rblAuthorizedRep.push({ value: 'No', htmlLabel: 'No' }, { value: 'Yes', htmlLabel: 'Yes' })
        this.rblMailCopy.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.showTermsButton = true
        this.paymentMethod = {} as typeof PaymentOptions
        this.ErrorMessages = [] as any[]
        this.rblRelation.push(
            { value: 'Aunt', text: 'Aunt' },
            { value: 'Brother', text: 'Brother' },
            { value: 'Caretaker', text: 'Caretaker' },
            { value: 'Case Worker', text: 'Case Worker' },
            { value: 'Companion', text: 'Companion' },
            { value: 'Cousin', text: 'Cousin' },
            { value: 'Daughter', text: 'Daughter' },
            { value: 'Daughter In Law', text: 'Daughter In Law' },
            { value: 'Father', text: 'Father' },
            { value: 'Father In Law', text: 'Father In Law' },
            { value: 'Friend', text: 'Friend' },
            { value: 'Grand Daughter', text: 'Grand Daughter' },
            { value: 'Grand Son', text: 'Grand Son' },
            { value: 'Home Provider', text: 'Home Provider' },
            { value: 'Hospice', text: 'Hospice' },
            { value: 'Husband', text: 'Husband' },
            { value: 'Mother In Law', text: 'Mother In Law' },
            { value: 'Mother', text: 'Mother' },
            { value: 'Nephew', text: 'Nephew' },
            { value: 'Niece', text: 'Niece' },
            { value: 'Power of Attorney', text: 'Power of Attorney' },
            { value: 'Program Coordinator', text: 'Program Coordinator' },
            { value: 'Other', text: 'Other' },
            { value: 'Residential Support', text: 'Residential Support' },
            { value: 'Son In Law', text: 'Son In Law' },
            { value: 'Sister', text: 'Sister' },
            { value: 'Son', text: 'Son' },
            { value: 'Social Worker', text: 'Social Worker' },
            { value: 'Step Daughter', text: 'Step Daughter' },
            { value: 'Step Son', text: 'Step Son' },
            { value: 'Wife', text: 'Wife' },
            { value: 'Spouse', text: 'Spouse' }
        )

        // this.paymentMethod = {} as EnrollmentFormViewModel
        this._stateGateway.getAllStates().subscribe((states: State[]) => (this.states = states))
    }

    ngOnInit() {
        //this.selectedPlan = 'SilverScript Choice'
        if (!this._global.currentUser) {
            var User = localStorage.getItem('UserSessionContext')
            this._global.currentUser = JSON.parse(User!)
        }

        this.planYear2018 = false
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        // this.visibleAfter2025 = (this._global.selectedPlanYear > this._global.Planyear2024);
        if (this.enrollment === null || this.enrollment === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step1'])
        }

        if (this.enrollment.AGENTID === null || this.enrollment.AGENTID === undefined || this.enrollment.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                //this.getEnrollmentDataResponse = this._enrollementGateway.getEnrollmentDataByKey(this.EnrollmentKey)

                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollment = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollment.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollment.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollment.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollment.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollment.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollment.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollment.FORMNAME = this.enrollmentCacheData.FORMNAME
                        this.enrollment.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT

                        this.loading = false
                        this.LoadData()
                        this.isAuthRep = !!(this.enrollment.AUTHREPIND && this.enrollment.AUTHREPIND == 'Yes')
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step1'])
            }
        } else {
            this.LoadData()
        }

        this.setOrgname()
        
        var APPDT = localStorage.getItem('APPDATE1'); 
       
        if (APPDT) {
            this.enrollment.APPDT = new Date(APPDT);
        }
        localStorage.removeItem('APPDATE1')
    }

    LoadData(): void {
        this.disableEffectiveDate = false
        this.isAuthRep = false
        // alert(this.paymentMethod.lastName)
        this.orgName = this._global.currentUser.insuranceCompanyName

        if (this.enrollment !== undefined) {
            this.selectedPlan = this.enrollment.PLANNAME
            this.rblAuthorizedRepClick(this.enrollment.AUTHREPIND)
            if (this.enrollment.SUBMISSIONTYPECODE === 'INCOMPLETE') {
                this.showTermsButton = false
            } else {
                this.showTermsButton = true
            }
        }
    }

    onSubmit(): void {
        this.isValidAgent = true
    }

    rblAuthorizedRepClick(event: any): void {
        if (event === 'Yes') {
            this.isAuthRep = true
        } else {
            this.isAuthRep = false
        }
        this.enrollment.AUTHREPIND = event
    }

    formSubmit(): void {
        if (!this.isFormInvalid()) {
            if (!this.isAuthRep) {
                this.enrollment.AUTHREPNAME = ''
                this.enrollment.AUTHREPPHONE = ''
                this.enrollment.AUTHREPREL = ''
                this.enrollment.AUTHREPADD1 = ''
                this.enrollment.AUTHREPCITY = ''
                this.enrollment.AUTHREPST = ''
                this.enrollment.AUTHREPZIP = ''
                this.enrollment.AUTHREPCOPYIND = ''
                this.enrollment.AUTHREPSIGNEDIND = false
            }
            localStorage.removeItem('APPDATE1')
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            let route = '/' + insCo + '/enrollment/data-entry/Step4'
            this.updateDataServiceCall(route)
        } else {
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }
    }
    onBeneficiarySignedChange(value: boolean) {
        this.enrollment.APPSIGNEDIND = value;
        
    }
    isFormInvalid(): boolean {
        this.ErrorMessages = [] as any[]
        this.hasError = false
        if (this.enrollment.APPSIGNEDIND === undefined || this.enrollment.APPSIGNEDIND === null || this.enrollment.APPSIGNEDIND === false) {
            this.ErrorMessages.push('Please check Beneficiary has signed application')
            this.hasError = true
        }
        if (this.enrollment.AUTHREPIND === undefined || this.enrollment.AUTHREPIND === null) {
            this.ErrorMessages.push('Authorized Representative is required')
            this.hasError = true
        }
        if (this.enrollment.APPDT === undefined || this.enrollment.APPDT === null) {
            this.ErrorMessages.push('Application Date is required')
            this.hasError = true
        }
        if (this.enrollment.EFFDT === undefined || this.enrollment.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasError = true
        } else {
            if (this.enrollment.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasError = true
            }
            if (this.enrollment.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasError = true
            }
            if (this.enrollment.APPDT && this.enrollment.EFFDT <= this.enrollment.APPDT) {
                this.ErrorMessages.push('Application date must be prior to the effective date.')
                this.hasError = true
            }
        }

        if (this.isAuthRep) {
            if (this.enrollment.AUTHREPSIGNEDIND === undefined || this.enrollment.AUTHREPSIGNEDIND === null || !this.enrollment.AUTHREPSIGNEDIND) {
                this.ErrorMessages.push('Please check Power of Attorney has signed application')
                this.hasError = true
            }
            if (this.enrollment.AUTHREPNAME === undefined || this.enrollment.AUTHREPNAME === '') {
                this.ErrorMessages.push('Authorized Representative  Name is required')
                this.hasError = true
            } else if (this.enrollment.AUTHREPNAME !== undefined && this.enrollment.AUTHREPNAME !== '' && this.enrollment.AUTHREPNAME !== null) {
                let checkAUTHREPNAME = this.enrollment.AUTHREPNAME
                let regexCityVal = /^[A-Za-z\s\-. ]+$/
                let isAUTHREPNAMEValid = regexCityVal.test(checkAUTHREPNAME)
                if (!isAUTHREPNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Authorized Representative  Name is invalid')
                }
            }
            if (this.enrollment.AUTHREPREL === undefined || this.enrollment.AUTHREPREL === '') {
                this.ErrorMessages.push('Authorized Representative  Relationship is required')
                this.hasError = true
            }
            if (this.enrollment.AUTHREPST === undefined || this.enrollment.AUTHREPST === '') {
                this.ErrorMessages.push('Authorized Representative  State is required')
                this.hasError = true
            }
            if (this.enrollment.AUTHREPADD1 === undefined || this.enrollment.AUTHREPADD1 === '') {
                this.ErrorMessages.push('Authorized Representative  Address is required')
                this.hasError = true
            }
            if (this.enrollment.AUTHREPCITY === undefined || this.enrollment.AUTHREPCITY === '') {
                this.ErrorMessages.push('Authorized Representative  City is required')
                this.hasError = true
            } else {
                let regexCityVal = /^[A-Za-z\s\-. ]+$/

                let isCityValid = regexCityVal.test(this.enrollment.AUTHREPCITY)
                if (!isCityValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter valid City')
                }
            }

            if (this.enrollment.AUTHREPZIP === undefined || this.enrollment.AUTHREPZIP === '') {
                this.ErrorMessages.push('Authorized Representative  Zip is required')
                this.hasError = true
            } else if (this.enrollment.AUTHREPZIP !== undefined && this.enrollment.AUTHREPZIP !== '' && this.enrollment.AUTHREPZIP !== null) {
                let checkZipCode = this.enrollment.AUTHREPZIP,
                    regexVal = new RegExp('[0-9]{5}')
                let isZipCodeValid = regexVal.test(checkZipCode)
                if (!isZipCodeValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Zip is invalid')
                }
            }

            if (this.enrollment.AUTHREPPHONE !== undefined && this.enrollment.AUTHREPPHONE !== '' && this.enrollment.AUTHREPPHONE !== null) {
                let checkOrgPhone = this.enrollment.AUTHREPPHONE.replace(/-/g, '')
                if (/^\d{10}$/.test(checkOrgPhone)) {
                } else {
                    if (!this.isValidNumber(checkOrgPhone)) {
                        this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                        this.hasError = true
                    } else {
                        this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                        this.hasError = true
                    }
                }
            }
        }

        if (this.enrollment.INDREPIND === 'Yes') {
            if (this.enrollment.INDREPNAME === undefined || this.enrollment.INDREPNAME === null || this.enrollment.INDREPNAME == '') {
                this.ErrorMessages.push('Individual Rep Name is required')
                this.hasError = true
            }
            if (this.enrollment.RELTOENROLL === undefined || this.enrollment.RELTOENROLL === null || this.enrollment.RELTOENROLL == '') {
                this.ErrorMessages.push('Relationship to enrollee is required')
                this.hasError = true
            }
            if (
                (this.enrollment.displayRELTOENROLL == 'Agent' || this.enrollment.displayRELTOENROLL == 'Broker') &&
                (this.enrollment.NPN === undefined || this.enrollment.NPN === null || this.enrollment.NPN == '')
            ) {
                this.ErrorMessages.push('National Producer Number is required')
                this.hasError = true
            }

            if (this.enrollment.NPN != undefined && this.enrollment.NPN != null && this.enrollment.NPN != '') {
                if (!this.utils.isValidNPN(this.enrollment.NPN)) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid NPN')
                }
            }
        }

        return this.hasError
    }

    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    goBack(): void {
        localStorage.setItem('APPDATE1', this.enrollment?.APPDT?.toString() ?? '');
        this.enrollment.APPDT = null
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step2'])
    }

    incompleteClick(): void {
        if (!this.incompleteClickValidation()) {
            this.enrollment.SUBMISSIONTYPECODE = 'INCOMPLETE'
            this.enrollment.PLANYEAR = String(this._global.selectedPlanYear)
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            let route = '/' + insCo + '/enrollment/data-entry/Confrimation'
            this.updateDataServiceCall(route)
        } else {
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }
    }
    incompleteClickValidation(): boolean {
        this.ErrorMessages = [] as any[]
        this.hasIncompleteError = false

        if (this.enrollment.APPDT === undefined || this.enrollment.APPDT === null) {
            this.ErrorMessages.push('Application Date is required')
            this.hasIncompleteError = true
        }
        if (this.enrollment.EFFDT === undefined || this.enrollment.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasIncompleteError = true
        } else {
            if (this.enrollment.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasIncompleteError = true
            }

            if (this.enrollment.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasIncompleteError = true
            }
            if (this.enrollment.APPDT && this.enrollment.EFFDT <= this.enrollment.APPDT) {
                this.ErrorMessages.push('Application date must be prior to the effective date.')
                this.hasIncompleteError = true
            }
        }
        if (this.isAuthRep) {
            if (this.enrollment.AUTHREPNAME === undefined || this.enrollment.AUTHREPNAME === '') {
                this.ErrorMessages.push('Authorized Representative  Name is required')
                this.hasIncompleteError = true
            } else if (this.enrollment.AUTHREPNAME !== undefined && this.enrollment.AUTHREPNAME !== '' && this.enrollment.AUTHREPNAME !== null) {
                let checkAUTHREPNAME = this.enrollment.AUTHREPNAME
                let regexCityVal = /^[A-Za-z\s\-. ]+$/
                let isAUTHREPNAMEValid = regexCityVal.test(checkAUTHREPNAME)
                if (!isAUTHREPNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Authorized Representative  Name is invalid')
                }
            }
            if (this.enrollment.AUTHREPREL === undefined || this.enrollment.AUTHREPREL === '') {
                this.ErrorMessages.push('Authorized Representative  Relationship is required')
                this.hasIncompleteError = true
            }
            if (this.enrollment.AUTHREPST === undefined || this.enrollment.AUTHREPST === '') {
                this.ErrorMessages.push('Authorized Representative  State is required')
                this.hasIncompleteError = true
            }
            if (this.enrollment.AUTHREPADD1 === undefined || this.enrollment.AUTHREPADD1 === '') {
                this.ErrorMessages.push('Authorized Representative  Address is required')
                this.hasIncompleteError = true
            }
            if (this.enrollment.AUTHREPCITY === undefined || this.enrollment.AUTHREPCITY === '') {
                this.ErrorMessages.push('Authorized Representative  City is required')
                this.hasIncompleteError = true
            } else {
                let regexCityVal = /^[A-Za-z\s\- .]+$/

                let isCityValid = regexCityVal.test(this.enrollment.AUTHREPCITY)
                if (!isCityValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Please enter valid City')
                }
            }

            if (this.enrollment.AUTHREPZIP === undefined || this.enrollment.AUTHREPZIP === '') {
                this.ErrorMessages.push('Authorized Representative  Zip is required')
                this.hasIncompleteError = true
            } else if (this.enrollment.AUTHREPZIP !== undefined && this.enrollment.AUTHREPZIP !== '' && this.enrollment.AUTHREPZIP !== null) {
                if (this.enrollment.AUTHREPZIP == '00000') {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Zip is invalid')
                } else {
                    let checkZipCode = this.enrollment.AUTHREPZIP,
                        regexVal = new RegExp('[0-9]{5}')
                    let isZipCodeValid = regexVal.test(checkZipCode)
                    if (!isZipCodeValid) {
                        this.hasIncompleteError = true
                        this.ErrorMessages.push('Zip is invalid')
                    }
                }
            }

            if (this.enrollment.AUTHREPPHONE !== undefined && this.enrollment.AUTHREPPHONE !== '' && this.enrollment.AUTHREPPHONE !== null) {
                let checkOrgPhone = this.enrollment.AUTHREPPHONE.replace(/-/g, '')
                if (/^\d{10}$/.test(checkOrgPhone)) {
                } else {
                    if (!this.isValidNumber(checkOrgPhone)) {
                        this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                        this.hasIncompleteError = true
                    } else {
                        this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                        this.hasIncompleteError = true
                    }
                }
            }
        }
        return this.hasIncompleteError
    }

    updateDataServiceCall(route: string) {
        if (this.enrollment.SUBMISSIONTYPECODE === 'INCOMPLETE') {
            this.enrollment.STEPCODE = ''

            if (!(this.enrollment.INDREPIND === 'Yes')) {
                this._indvRepComponent.selectedNo(this.enrollment)
            }

            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            //this.router.navigate([route])
            this.loading = true
            this._enrollementGateway.SubmitEnrollmentData(this.enrollment).subscribe(
                (model: SubmitEnrollmentDataResponse) => {
                    let response = model
                    if (response !== undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        } else {
                            if (response.EnrollmentKey !== undefined && response.EnrollmentKey !== '' && response.EnrollmentKey !== null) {
                                this.enrollment.ENROLLKEY = response.EnrollmentKey
                                this.enrollment.CONF = response.confirmationNumber
                                this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                this.loading = false
                                this.router.navigate([route])
                            } else {
                                this.ErrorMessages.push('Error while submitting data, please try again.')
                                this.hasError = true
                                this.focusableEleTop.nativeElement.focus()
                            }
                        }
                    } else {
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                    }
                    this.loading = false
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.enrollment.SUBMISSIONTYPECODE = 'PROSPECT'

            this.loading = true
            if (this.enrollment.ELECTION !== undefined && this.enrollment.ELECTION === 'OpenEnrollment') {
                this.disableEffectiveDate = true
                this.CheckUpdateApplicationDateForAEP()
            } else {
                this.disableEffectiveDate = false
            }
            this.enrollment.STEPCODE = '3'
            //this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            //this.router.navigate([route])
            this._enrollementGateway
                .validateZipForAll(this.enrollment.APPST, this.enrollment.APPZIP, '0', '0', this.enrollment.AUTHREPST, this.enrollment.AUTHREPZIP)
                .subscribe(
                    (model: string[]) => {
                        if (model !== undefined && model !== null && model.length !== 0) {
                            this.ErrorMessages = model
                            console.log(this.ErrorMessages)
                            this.hasError = true
                            window.scrollTo(0, 0)
                            this.loading = false
                        } else {
                            //Remove Data fro the Individual
                            if (!(this.enrollment.INDREPIND === 'Yes')) {
                                this._indvRepComponent.selectedNo(this.enrollment)
                            }
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)

                            this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe(
                                (model: SubmitEnrollmentDataResponse) => {
                                    this.loading = false
                                    let response = model
                                    if (response !== undefined) {
                                        if (response.Errors !== undefined && response.Errors.length > 0) {
                                            this.hasError = true

                                            for (let i = 0; i < response.Errors.length; i++) {
                                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                            }
                                            this.focusableEleTop.nativeElement.focus()
                                        } else {
                                            //this.enrollment.ENROLLKEY = response.EnrollmentKey
                                            //this.enrollment.CONF = response.confirmationNumber
                                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                            this.router.navigate([route])
                                        }
                                    } else {
                                        this.ErrorMessages.push('Error while submitting data, please try again.')
                                        this.focusableEleTop.nativeElement.focus()
                                    }
                                },
                                (err) => {
                                    this.loading = false
                                }
                            )
                        }
                    },
                    (err) => {
                        this.loading = false
                    }
                )
        }
    }

    CheckUpdateApplicationDateForAEP() {
        if (
            this._global.selectedPlanYear !== undefined &&
            this._global.selectedPlanYear !== 0 &&
            this.enrollment.APPDT !== undefined &&
            this.enrollment.APPDT !== null &&
            this.enrollment.DATEOFRECEIPT !== undefined &&
            this.enrollment.DATEOFRECEIPT !== null
        ) {
            let planYr: string
            let dateOfReceipt: Date
            let contactType: string
            let minAppDt: Date
            let maxAppDt: Date
            planYr = String(this._global.selectedPlanYear - 1)
            dateOfReceipt = new Date(this.enrollment.DATEOFRECEIPT)
            minAppDt = new Date('10/01/' + planYr)
            maxAppDt = new Date('10/15/' + planYr)
            contactType = this.enrollment.AGENTDEX

            if (
                dateOfReceipt >= minAppDt &&
                dateOfReceipt <= maxAppDt &&
                this.enrollment.APPDT >= minAppDt &&
                this.enrollment.APPDT <= maxAppDt &&
                (contactType.toLowerCase() == 'fax' ||
                    contactType.toLowerCase() == 'paper' ||
                    contactType.toLowerCase() == 'mail' ||
                    contactType.toLowerCase() == 'mlpap')
            ) {
                this.enrollment.APPDT = new Date('10/15/' + planYr)
            }
        }
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    private setOrgname() {
        if (this._global.selectedPlanYear === 0 || this._global.selectedPlanYear === undefined) {
            if (sessionStorage.getItem('PLANYEAR') !== undefined) {
                this._global.selectedPlanYear = Number(sessionStorage.getItem('PLANYEAR'))
            }
        }
        if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
            this.insuranceCompany = this.orgName
            this.insuranceCompanyShortName = this._global.insCompanyNameSSI
            this.insComAetnaPdp = this.orgName
            this.insuranceCompanyFullShort = this.orgName
        } else {
            this.insuranceCompany = this._global.insuranceCompanyNameAetna
            this.insuranceCompanyShortName = this._global.insuranceCompanyNameAetna
            this.insComAetnaPdp = this._global.insCompanyNameAetnaPdp
            this.insuranceCompanyFullShort = this._global.insuranceCompanyNameAetna
        }
    }
}
